module.exports = __webpack_public_path__ + "img/mesa_el_a.9dd47013.png";